var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 23.4",
    style: {
      enableBackground: "new 0 0 50 23.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "media-play-symbol",
    transform: "translate(44 -43.137) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_8_16_",
    transform: "translate(43.137 -6)",
    fill: "#0FD7C3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    d: "M22.5,49.8C22.3,49.9,22,50,21.7,50c-0.3,0-0.6-0.1-0.8-0.2l-20-23.3c0,0-0.8-0.9-0.8-1.5s0.8-1.5,0.8-1.5 l20-23.3c0.8-0.5,1.8-0.2,2.3,0.6c0.1,0.3,0.2,0.5,0.2,0.8v46.6C23.4,48.9,23.1,49.5,22.5,49.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrow);
export default __webpack_public_path__ + "static/media/iconArrow.b18effaf8fa40f012c4d51ee686d3ec5.svg";
export { ForwardRef as ReactComponent };